<router-outlet></router-outlet>
<ngx-spinner
    [fullScreen]="true"
    bdColor="rgba(0, 0, 0, 0.8)"
    color="#fff"
    name="loading"
    size="medium"
    type="ball-clip-rotate-multiple">
    <p class="text-white">Loading...</p>
</ngx-spinner>
<ngx-spinner
    [fullScreen]="true"
    bdColor="rgba(0, 0, 0, 0.8)"
    color="#fff"
    size="medium"
    type="ball-clip-rotate-multiple">
    <p class="text-white">Submitting...</p>
</ngx-spinner>
